import React, { useMemo, useRef } from 'react';
import { useLocation, useNavigate, BrowserRouter } from 'react-router-dom';
import { AppConfigV2 } from '@shopify/app-bridge';
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import { AppProvider as PolarisAppProvider } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';

import Routes from './routes';
import Link from './components/Link';
import { getAppConfig } from './utils/misc';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const appConfigRef = useRef<AppConfigV2 | null>(null);

  function createAppConfig() {
    let appConfig = appConfigRef.current;

    if (appConfig !== null) {
      return appConfig;
    }

    appConfig = getAppConfig();

    if (appConfig !== null) {
      appConfigRef.current = appConfig;
      return appConfig;
    }
  }

  const history = useMemo(
    () => ({replace: (path: string) => navigate(path, {replace: true})}),
    [navigate],
  );

  const router = useMemo(
    () => ({
      location,
      history,
    }),
    [location, history],
  );

  const appConfig = createAppConfig();

  return (
    <PolarisAppProvider
      i18n={translations}
      linkComponent={Link}
    >
      {appConfig ? (
        <AppBridgeProvider
          config={appConfig}
          router={router}
        >
          <Routes />
        </AppBridgeProvider>
      ) : (
        <Routes />
      )}
    </PolarisAppProvider>
  );
};

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}


export default AppWrapper;
